import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { RestaurantsSlice } from '.'
import { AppDispatch } from '../../index'
import { IFetchRestaurants, IRestaurant } from './types'

export const getRestaurants =
  (params: IFetchRestaurants) => async (dispatch: AppDispatch) => {
    try {
      const restaurants: IRestaurant[] = await qrMenuGET.restaurants(
        params.ActiveBranchID
      )
      dispatch(RestaurantsSlice.actions.setRestaurants(restaurants))
    } catch (e) {
      console.log('restaurants request failure')
    }
  }
